import { AmbassadorsAbout, AmbassadorsAboutProps } from './ambassadors-about'
import { AmbassadorsHero, AmbassadorsHeroProps } from './ambassadors-hero'
import { AmbassadorsMore, AmbassadorsMoreProps } from './ambassadors-more'
import { AmbassadorsRoles, AmbassadorsRolesProps } from './ambassadors-roles'
import { ContactUs, ContactUsProps } from './contact-us'
import { DontMissOut, DontMissOutProps } from './dont-miss-out'
import { FaqDiscord, FaqDiscordProps } from './faq-discord'
import { FaqPage, FaqPageProps } from './faq-page'
import { GetLiquidity, GetLiquidityProps } from './get-liquidity'
import { HomeHero, HomeHeroProps } from './home-hero'
import { HowItWorks, HowItWorksProps } from './how-it-works'
import { HowItWorksHero, HowItWorksHeroProps } from './how-it-works-hero'
import { HowItWorksSections, HowItWorksSectionsProps } from './how-it-works-sections'
import { JoinUs, JoinUsProps } from './join-us'
import { Questions, QuestionsProps } from './questions'
import { RichText, RichTextProps } from './rich-text'
import { Testimonials, TestimonialsProps } from './testimonials'
import { TopCollections, TopCollectionsProps } from './top-collections'
import { WhyNftfi, WhyNftfiProps } from './why-nftfi'

export const Blocks = {
  AmbassadorsAbout,
  AmbassadorsHero,
  AmbassadorsMore,
  AmbassadorsRoles,
  ContactUs,
  DontMissOut,
  FaqDiscord,
  FaqPage,
  GetLiquidity,
  HomeHero,
  HowItWorks,
  HowItWorksHero,
  HowItWorksSections,
  JoinUs,
  Questions,
  RichText,
  Testimonials,
  TopCollections,
  WhyNftfi,
}

export type Block =
  | AmbassadorsAboutProps
  | AmbassadorsHeroProps
  | AmbassadorsMoreProps
  | AmbassadorsRolesProps
  | ContactUsProps
  | DontMissOutProps
  | FaqDiscordProps
  | FaqPageProps
  | GetLiquidityProps
  | HomeHeroProps
  | HowItWorksProps
  | HowItWorksHeroProps
  | HowItWorksSectionsProps
  | JoinUsProps
  | QuestionsProps
  | RichTextProps
  | TestimonialsProps
  | TopCollectionsProps
  | WhyNftfiProps
